import { BreakPoint } from '@/hooks/useBreakPoint/consts';
import LegacyPicture from '../LegacyPicture/LegacyPicture';
import StageBoxText from '../StageBoxText/StageBoxText';
import styles from './HeatPumpStageBox.module.scss';
import type { HeatPumpStageBoxProps } from './types';

const HeatPumpStageBox = ({ image, ...props }: HeatPumpStageBoxProps) => {
  return (
    <div className={styles.base}>
      <div className={styles.stageboxWrapper}>
        <StageBoxText {...props} />
      </div>

      <div className={styles.imageWrapper}>
        <LegacyPicture
          asset={image}
          className={styles.image}
          breakpointAspectRatioConfigs={[
            {
              breakpoint: BreakPoint.XSS,
              width: 350,
            },
            {
              breakpoint: BreakPoint.SM,
              width: 600,
            },
            {
              breakpoint: BreakPoint.MD,
              width: 344,
            },
            {
              breakpoint: BreakPoint.LG,
              width: 552,
            },
            {
              breakpoint: BreakPoint.XL,
              width: 632,
            },
          ]}
        />
      </div>
    </div>
  );
};

export default HeatPumpStageBox;
